/* ============
 * State of the Unit-types module
 * ============
 *
 * The initial state of the Unit-types module.
 */

export default {
  unitTypes: [],
  typePanoramas: {},
};
